/*
 * PureLink spec-table classifier.
 * Product spec tables are authored as plain <table> markup (no classes) inside the
 * product tabs / rich-text. This walks those tables and adds the .pl-spec-* classes
 * that pl-custom.css styles:
 *   - heading row  = single cell, or a colspan cell, or a row whose 2nd cell is empty
 *   - data row     = label + value  (.pl-spec-row)
 *   - last data row before a heading = .pl-spec-last-in-group
 * Kept as its own asset so theme-version updates don't wipe it (the include line in
 * theme.liquid is the only vendor-file hook — see the re-apply script).
 */
(function () {
  var pending = false;

  function stylePureLinkSpecTables() {
    var tables = document.querySelectorAll(
      '.station-tabs-tabcontent table, ' +
      '.product__description table, ' +
      '.product__accordion table, ' +
      '.product-info table, ' +
      '.rte table, ' +
      '.tab-content table, ' +
      '.tabs-content table, ' +
      'main table'
    );

    tables.forEach(function (table) {
      // Never touch the download table — it has its own #pl-download-tab styling.
      if (table.classList.contains('pl-download-table') || table.closest('#pl-download-tab')) {
        return;
      }

      var rows = Array.from(table.querySelectorAll('tr'));

      // Spec tables are label/value pairs. Anything wider (a comparison matrix, say) must NOT get
      // the 2-column grid treatment - .pl-spec-row is `display: grid` with two tracks, so cells 3+
      // wrap into phantom rows and the authored <col> widths are hidden. Hand those to the plain
      // bordered .pl-wide-table styling instead. Class-only change: this file's MutationObserver
      // re-runs on every DOM change, so inserting a wrapper element here would loop.
      var widestRow = 0;
      rows.forEach(function (row) {
        var count = row.querySelectorAll('td, th').length;
        if (count > widestRow) widestRow = count;
      });

      if (widestRow > 2) {
        table.classList.remove('pl-spec-table');
        table.classList.add('pl-wide-table');
        rows.forEach(function (row) {
          row.classList.remove('pl-spec-heading', 'pl-spec-row', 'pl-spec-last-in-group');
        });
        return;
      }

      table.classList.remove('pl-wide-table');
      table.classList.add('pl-spec-table');

      rows.forEach(function (row) {
        row.classList.remove(
          'pl-spec-heading',
          'pl-spec-row',
          'pl-spec-last-in-group'
        );

        var cells = row.querySelectorAll('td, th');
        if (!cells.length) return;

        var firstText = cells[0]
          ? cells[0].textContent.replace(/ /g, ' ').trim()
          : '';
        var secondText = cells[1]
          ? cells[1].textContent.replace(/ /g, ' ').trim()
          : '';

        var isHeading =
          cells.length === 1 ||
          cells[0].hasAttribute('colspan') ||
          (firstText.length > 0 && cells.length >= 2 && secondText.length === 0);

        row.classList.add(isHeading ? 'pl-spec-heading' : 'pl-spec-row');
      });

      rows.forEach(function (row, index) {
        if (!row.classList.contains('pl-spec-row')) return;
        var nextRow = rows[index + 1];
        if (!nextRow || nextRow.classList.contains('pl-spec-heading')) {
          row.classList.add('pl-spec-last-in-group');
        }
      });
    });
  }

  function scheduleStyle() {
    if (pending) return;
    pending = true;
    window.setTimeout(function () {
      pending = false;
      stylePureLinkSpecTables();
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', stylePureLinkSpecTables);
  window.addEventListener('load', stylePureLinkSpecTables);
  setTimeout(stylePureLinkSpecTables, 300);
  setTimeout(stylePureLinkSpecTables, 1000);
  setTimeout(stylePureLinkSpecTables, 2000);

  // The tabs app renders content dynamically, so re-classify on DOM changes.
  var observer = new MutationObserver(scheduleStyle);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
